import React from 'react'

export default () => (
    <div>
		Console
	</div>
)